import gsap from 'gsap';
import { getBounds, handleEvent, inViewport } from '../../helpers';

export default class {
  constructor(el) {
    this.DOM = {
      el: el || null,
      container: window
    }

    // console.log(el);

    this.options = {
      threshold: this.DOM.el.dataset.jsThreshold || 20,
      speed: this.DOM.el.dataset.jsSpeed ||1
    }

    this.rendering = false
  }

  init() {
    inViewport(this.DOM.el, {
      inside: () => {
        if (!this.rendering) {
          this.initEvents()
        }
      },
      outside: () => {
        if (this.rendering) {
          this.destroy()
        }
      }
    })
  }

  initEvents() {
    if (!this.DOM.el) return;

    return new Promise((resolve) => {
      this._addEvents()
      this._setState()
      gsap.ticker.add(this._render)
      this.rendering = true
      resolve()
    })
  }

  _setState() {
    if (!this.DOM.el) return;

    this.state = {
      iX: 0,
      iY: 0,
      mousePosition: {
        x: getBounds(this.DOM.el).x + getBounds(this.DOM.el).width / 2,
        y: getBounds(this.DOM.el).y + getBounds(this.DOM.el).height / 2
      },
      pos: getBounds(this.DOM.el)
    }
  }

  _render = () => {
    this.state.iX = this.state.pos.x + (this.state.pos.width / 2);
    this.state.iY = this.state.pos.y + (this.state.pos.height / 2);
    this.state.cX = (this.state.mousePosition.x - this.state.iX) / this.options.threshold;
    this.state.cY = (this.state.mousePosition.y - this.state.iY) / this.options.threshold;

    gsap.to(this.DOM.el, {
      duration: this.options.speed,
      x: this.state.cX,
      y: this.state.cY
    })
  }

  _handleMousemove(e) {
    this.state.mousePosition = { x: e.clientX, y: e.clientY };
  }

  _handleMousedown() {

  }

  _handleMouseleave() {
    this._setState();
  }

  _addEvents() {
    this.mouseleave = handleEvent('mouseleave', {
      el: this.DOM.container,
      callback: this._handleMouseleave.bind(this)
    })

    this.mousemove = handleEvent('mousemove', {
      el: this.DOM.container,
      stopPropagation: false,
      callback: this._handleMousemove.bind(this)
    })
  }

  setOptions({ threshold = this.options.threshold, speed = this.options.speed }) {
    this.options.threshold = threshold
    this.options.speed = speed
  }

  destroy() {
    if (!this.DOM.el) return;

    this.rendering = false

    gsap.ticker.remove(this._render)

    this.mousemove.destroy()
    this.mousemove = null

    this.mouseleave.destroy()
    this.mouseleave = null

    this.state = null
  }
}
